import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconWrapper } from '@honda-canada/design-system-react';
import themeStyles from './DealerDetailsModal.style';

const CloseButton = themeStyles.apply('button', 'CloseButton');

const ModalCloseButton = ({ isFixed, onClick, iconSize, ariaLabel, styling }) => (
  <CloseButton
    isFixed={isFixed}
    onClick={onClick}
    aria-label={ariaLabel}
    tab-index="1"
    styling={styling}
    data-testid="close-button"
  >
    <IconWrapper size="iconWrapper.md">
      <Icon name="close" iconSize={iconSize} />
    </IconWrapper>
  </CloseButton>
);

ModalCloseButton.defaultProps = {
  isFixed: false,
  iconSize: 'default',
};

ModalCloseButton.propTypes = {
  isFixed: PropTypes.bool,
  onClick: PropTypes.func,
  iconSize: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  styling: PropTypes.string,
};

export default ModalCloseButton;
